<div class="congrats-challenge" *ngIf="congratsChallenge">
  <h2>{{"BANNER_CHALLENGE.CONGRATS" | translate}}</h2>
  <p>{{"BANNER_CHALLENGE.CONGRATS_MSG" | translate}}</p>
  <p>{{"BANNER_CHALLENGE.CONGRATS_MSG2" | translate}}</p>
  <p class="challenge-name">{{congratsChallenge?.i18nName[translate.currentLang.toUpperCase()]}}</p>
</div>
<div class="container">
  <h1 *ngIf="guiService.userLogged && guiService.userLogged.masterData">{{"USER_TRANS.HI" | translate}} {{guiService.userLogged.masterData.name}}!</h1>
  <div class="banner-sfida" *ngIf="guiService.timeChallengeBanner" (click)="this.guiService.lastAcceptedChallenge ? goToWellnessArea() : null">
      <h3 *ngIf="!this.guiService.lastAcceptedChallenge">{{guiService.timeChallengeBanner.videos[0].i18nName[translate.currentLang.toUpperCase()]}}</h3>
      <p class="date" *ngIf="!this.guiService.lastAcceptedChallenge">{{guiService.timeChallengeBanner.videos[0].publishDate | date: 'shortDate'}} - {{guiService.timeChallengeBanner.videos[0].expirationDate | date: 'shortDate'}}</p>
      <span *ngIf="!this.guiService.lastAcceptedChallenge">
        <p class="description">{{"BANNER_CHALLENGE.DESCRIPTION" | translate}}</p>
        <button class="join-challenge" (click)="selectChallenge()">{{"BANNER_CHALLENGE.BTN" | translate}}</button>
      </span>
      <span *ngIf="this.guiService.lastAcceptedChallenge && showCountdown">
        <h3>{{guiService.lastAcceptedChallenge?.i18nName[translate.currentLang.toUpperCase()]}}</h3>
        <p class="date">{{guiService.timeChallengeBanner.videos[0].publishDate | date: 'shortDate'}} - {{guiService.timeChallengeBanner.videos[0].expirationDate | date: 'shortDate'}}</p>
        <p class="chall-start-at">{{"BANNER_CHALLENGE.CHALL_START_AT" | translate}}</p>
        <div class="chall-countdown">
          <div>
          <span class="box">
            {{countdown && countdown.days < 10 ? 0 : null}}{{ countdown?.days }}
          </span>
          <p>{{"BANNER_CHALLENGE.DAYS" | translate}}</p>
          </div>
         <span class="point-divider">:</span>
          <div>
          <span class="box">
            {{countdown && countdown.hours < 10 ? 0 : null}}{{ countdown?.hours }}
          </span>
          <p>{{"BANNER_CHALLENGE.HOURS" | translate}}</p>
          </div>
          <span class="point-divider">:</span>
          <div>
          <span class="box">
            {{countdown && countdown.minutes < 10 ? 0 : null}}{{ countdown?.minutes }}
          </span>
          <p>{{"BANNER_CHALLENGE.MINUTES" | translate}}</p>
          </div>
          <span class="point-divider">:</span>
          <div>
          <span class="box">
            {{countdown && countdown.seconds < 10 ? 0 : null}}{{ countdown?.seconds }}
          </span>
           <p>{{"BANNER_CHALLENGE.SECS" | translate}}</p>
          </div>
        </div>
      </span>
      <span *ngIf="guiService.lastAcceptedChallenge && !showCountdown" class="chall-ends">
        <h4>{{"BANNER_CHALLENGE.PARTECIPATING_AT" | translate}}</h4>
        <h3>{{guiService.lastAcceptedChallenge?.i18nName[translate.currentLang.toUpperCase()]}}</h3>
        <p class="chall-end-at" *ngIf="showStartedChallengeDate">{{"BANNER_CHALLENGE.CHALL_END_AT" | translate}}</p>
        <p class="weeks-out" *ngIf="showStartedChallengeDate">{{challengeStartedBy()}}</p>
      </span>
    </div>
  <div class="week_title">
    <div class="w-70"></div>
      <form [formGroup]="form" *ngIf="risposta">
        <mat-form-field appearance="fill" id="homeMat">
          <mat-select formControlName="weekControl" (selectionChange)="changeWeek()">
            <mat-option *ngFor="let week of risposta.weeks; let i = index" [value]="i">
              {{"week "+i}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        </form>
    </div>
  <div class="week">

    <div class="thunders" *ngIf="guiService.userLogged" [class.thunder-opacity]="showThunders == false">
      <span class="thunderbolt"  *ngFor="let day of days; let i = index" (click)="selectSlide(i)">
        <div [class.current_day]="guiService.userLogged.lastWorkoutProgram.day == i" [class.passed_day]="isExecutedDay(i)">
          <span class="material-symbols-outlined">
            flash_on
            </span>
        </div>
        <p [class.current_day]="guiService.userLogged.lastWorkoutProgram.day == i">day {{i+1}}</p>
      </span>
    </div>
    <div *ngIf="showThunders == false" class="thunder-spinner">
      <fa-icon class="flash" [icon]="icon.faEll"></fa-icon>
    </div>
  </div>

  <h2>{{"USER_TRANS.D_WORK" | translate}}</h2>
  <div class="w_daily" *ngIf="selectedWeek" [class]="evaluateBgColor(i)" [style.background-image]="'url('+environment+'/'+selectedWeek['workoutIdDay'+(i+1)]+'/images/main)'" [class.rest]="selectedWeek['workoutIdDay'+(i+1)] == null">
    <button (click)='getPrev()'><mat-icon svgIcon="mat:arrow_back_ios"></mat-icon></button>
    <div class="carousel-inner"  role="listbox" (click)="programDetails()">
      <span class="w-title" *ngIf="selectedWeek['workoutIdDay'+(i+1)] != null">{{filteredIds[selectedWeek["workoutIdDay"+(i+1)]]}}</span>
      <span *ngIf="selectedWeek['workoutIdDay'+(i+1)] == null" class="w-title restTitle">rest</span>
    </div>
    <button (click)='getNext()'><mat-icon svgIcon="mat:arrow_forward_ios"></mat-icon></button>
  </div>

  <h2>{{"USER_TRANS.W_WORK" | translate}}</h2>
  <div class="w_oftheweek">
    <div class="days" *ngIf="guiService.userLogged && selectedWeek">
      <span><fa-icon [icon]="icon.faCalendar"></fa-icon>{{"WORKOUT-PROG.DAY1" | translate}}: {{selectedWeek["workoutIdDay1"]?filteredIds[selectedWeek["workoutIdDay1"]]:'REST'}}</span>
      <span><fa-icon [icon]="icon.faCalendar"></fa-icon>{{"WORKOUT-PROG.DAY2" | translate}}: {{selectedWeek["workoutIdDay2"]?filteredIds[selectedWeek["workoutIdDay2"]]:'REST'}}</span>
      <span><fa-icon [icon]="icon.faCalendar"></fa-icon>{{"WORKOUT-PROG.DAY3" | translate}}: {{selectedWeek["workoutIdDay3"]?filteredIds[selectedWeek["workoutIdDay3"]]:'REST'}}</span>
      <span><fa-icon [icon]="icon.faCalendar"></fa-icon>{{"WORKOUT-PROG.DAY4" | translate}}: {{selectedWeek["workoutIdDay4"]?filteredIds[selectedWeek["workoutIdDay4"]]:'REST'}}</span>
      <span><fa-icon [icon]="icon.faCalendar"></fa-icon>{{"WORKOUT-PROG.DAY5" | translate}}: {{selectedWeek["workoutIdDay5"]?filteredIds[selectedWeek["workoutIdDay5"]]:'REST'}}</span>
      <span><fa-icon [icon]="icon.faCalendar"></fa-icon>{{"WORKOUT-PROG.DAY6" | translate}}: {{selectedWeek["workoutIdDay6"]?filteredIds[selectedWeek["workoutIdDay6"]]:'REST'}}</span>
      <span><fa-icon [icon]="icon.faCalendar"></fa-icon>{{"WORKOUT-PROG.DAY7" | translate}}: {{selectedWeek["workoutIdDay7"]?filteredIds[selectedWeek["workoutIdDay7"]]:'REST'}}</span>
    </div>
  </div>

</div>
